import React from 'react';
import { symptoms } from '../data/offer';
export function HookSection() {
  return <section className="w-full bg-cream-100" aria-labelledby="gancho-titulo" data-id="element-65" data-mp="7in9frgnkkc6">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 py-16 lg:grid-cols-[0.85fr_1.15fr] lg:items-center lg:py-24" data-id="element-66" data-mp="7gj7vg687xf2">
        <img src="https://cdn.magicpatterns.com/patterns/generated-images/86eeb310-b94d-4eca-9c19-d2405bb22c63.jpg" alt="Perro labrador adulto mirando a cámara con expresión tranquila" className="aspect-square w-full rounded-3xl object-cover shadow-lg" data-id="element-67" data-mp="h8fb15n66dq5" />
        <div data-id="element-68" data-mp="2j0y5nkdxe60">
          <h2 id="gancho-titulo" className="font-display text-3xl font-bold leading-tight text-forest-900 sm:text-4xl" data-id="element-69" data-mp="2jsks8w081k5">
            ¿Alguna vez has mirado a tu perro a los ojos y has sentido ese miedo frío de saber que
            su vida es demasiado corta?
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-forest-800/80" data-id="element-70" data-mp="19xm59sflch5l">
            Peor aún... ¿has sentido la frustración de pagar una factura veterinaria de{' '}
            <strong className="font-semibold text-forest-900" data-id="element-71" data-mp="3m013xmxprcn4">$50.000 o $100.000 pesos</strong> por
            un problema de salud que sabes que podrías haber evitado?
          </p>

          <div className="mt-8 rounded-2xl border-l-4 border-clay-500 bg-cream-200/70 p-6" data-id="element-72" data-mp="3pzjtwx4e6dwt">
            <p className="text-sm font-semibold uppercase tracking-wide text-clay-600" data-id="element-73" data-mp="3uymvu8p2s40k">
              Señales de auxilio
            </p>
            <ul className="mt-3 flex flex-wrap gap-2" data-id="element-74" data-mp="32bk0tqjlybf2">
              {symptoms.map(symptom => <li key={symptom} className="rounded-full bg-white px-3 py-1.5 text-sm font-medium text-forest-800 shadow-sm" data-id="element-75" data-mp="37amwikdp75ad">
                  {symptom}
                </li>)}
            </ul>
            <p className="mt-4 leading-relaxed text-forest-800/85" data-id="element-76" data-mp="2ekekzbdo3j4r">
              Si tu perro tiene alguna de estas señales, su cuerpo te está pidiendo ayuda. Y la
              solución no está en más medicamentos químicos, sino en su biología.
            </p>
          </div>
        </div>
      </div>
    </section>;
}